import { useState } from "react";
import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import { t } from "i18next";

export const useServiceProviderDetailsTabMenuUtils = () => {
  const [menuGroup, setMenuGroup] = useState(() => {
    const tempMenuGroup = [];

    /* menuItemDetails */
    const menuItemDetails = {
      id: "service-provider-details-details",
      title: t("Modules.Provider.details"),
      url: baseRouteMakerForSuperAdmin(routes.SERVICE_PROVIDER_DETAILS_DETAILS),
    };
    tempMenuGroup.push(menuItemDetails);
    /* menuItemDetails */

    /* menuItemServices */
    const menuItemServices = {
      id: "service-provider-services",
      title: t("Modules.Provider.services"),
      url: baseRouteMakerForSuperAdmin(routes.SERVICE_PROVIDER_DETAILS_SERVICE_DETAILS),
    };
    tempMenuGroup.push(menuItemServices);
    /* menuItemServices */

    /* menuItemAppointments */
    const menuItemAppointments = {
      id: "service-provider-appointments-details",
      title: t("Modules.Provider.appointments"),
      url: baseRouteMakerForSuperAdmin(routes.SERVICE_PROVIDER_DETAILS_APPOINTMENT_DETAILS),
    };
    tempMenuGroup.push(menuItemAppointments);
    /* menuItemAppointments */

    /* menuItemSubscriptionPayment */
    const menuItemSubscriptionPayment = {
      id: "service-provider-subscription-payment",
      title: t("Modules.Provider.subscriptionPayment"),
      url: baseRouteMakerForSuperAdmin(routes.SERVICE_PROVIDER_DETAILS_SUBSCRIPTION_PAYMENT),
    };
    tempMenuGroup.push(menuItemSubscriptionPayment);
    /* menuItemSubscriptionPayment */

    /* menuItemStaff */
    const menuItemStaff = {
      id: "super-admin-staff",
      title: t("dashboard.Staff"),
      url: baseRouteMakerForSuperAdmin(routes.SERVICE_PROVIDER_DETAILS_STAFF),
    };
    tempMenuGroup.push(menuItemStaff);
    /* menuItemStaff */

    /* menuItemOffers */
    const menuItemOffers = {
      id: "super-admin-offers",
      title: t("dashboard.Offers"),
      url: baseRouteMakerForSuperAdmin(routes.SERVICE_PROVIDER_DETAILS_OFFERS),
    };
    tempMenuGroup.push(menuItemOffers);
    /* menuItemOffers */

    /* menuItemPackages */
    const menuItemPackages = {
      id: "super-admin-packages",
      title: t("dashboard.Packages"),
      url: baseRouteMakerForSuperAdmin(routes.SERVICE_PROVIDER_DETAILS_PACKAGES),
    };
    tempMenuGroup.push(menuItemPackages);
    /* menuItemPackages */

    return tempMenuGroup;
  });

  return menuGroup;
};
